import validatePaidCampaign from '@helpers/validatePaidCampaign';
import axios from 'axios';
import React from 'react';
import EinCheckoutComponent from '@/components/EIN/checkout/EINCheckoutComponent';
import FooterComponent from '@/components/Footer/FooterComponent';
import Header from '@/components/Header/Header';
import SEOHead from '@/components/SEOHead/SEOHead';
import { CLPStyles } from '@/components/styles/CLPStyles';
import { WordPressAPI } from '../../../../config';

const EinCheckout = ({ data }) => {
  const {
    checkout_page: checkoutPage,
    lead_values: leadValues,
    phone_number_setup,
    additional_questions,
  } = data.acf;

  const paid_campaign = validatePaidCampaign(data.acf.paid_campaign);
  return (
    <>
      <SEOHead>
        <title>{checkoutPage.title_tag}</title>
        <meta name="description" content={checkoutPage.meta_description} />
        <meta name="robots" content="noindex" />
      </SEOHead>
      <CLPStyles>
        <Header
          AdditionalQuestions={additional_questions}
          PaidCampaign={typeof (paid_campaign) === 'undefined' ? 1 : paid_campaign}
          hidePhone
          phone_number={phone_number_setup}
          leadValues={leadValues}
        />
        <EinCheckoutComponent
          leadValues={leadValues}
          phone={phone_number_setup?.online_phone_number || ''}
        />
        <FooterComponent
          phone_number={phone_number_setup}
        />
      </CLPStyles>
    </>
  );
};

export const getStaticProps = async () => {
  const { data } = await axios.get(`${WordPressAPI.pages}/12545`);

  return {
    props: {
      data,
    },
  };
};

export default EinCheckout;
